'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _styledComponents2.default.div.withConfig({
  componentId: 's1mq0bkl-0'
})(['margin-bottom:', ';&::after{content:\'\';display:block;clear:both;}', ''], function (p) {
  return p.theme.spacingUnit;
}, function (p) {
  return p.hidden && '\n    display: none;\n  ';
});